export const getPatientName = (
  name: string | null,
  index: number,
  displayPhi: boolean,
) => {
  if (!name) {
    return `Patient ${index + 1}`;
  }

  let patientNameToDisplay = name.replace('^', ' ');

  if (!displayPhi) {
    patientNameToDisplay = patientNameToDisplay
      .replace('^', ' ')
      .split(' ')
      .map((n) => `${n[0]}${'*'.repeat(5)}`)
      .join(' ');
  }

  return patientNameToDisplay;
};
